import { create } from 'jss'
import preset from 'jss-preset-default'

export const jss = create(preset())